"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=dynamodb.js.map